export default __webpack_public_path__ + "static/media/health.27a85af3.svg";